export default __webpack_public_path__ + "static/media/background.3f493a76.jpg";